import { Routes } from '@angular/router';
import { TitleResolver } from '../resolver/metatitles/metatitles.resolver';
import { RoleAccountGuard } from '../../guards/role-account.guard';
import { DeliverysComponent } from '../../pages/deliverys/deliverys.component';


export const deliverysRoutes: Routes = [
  {
    path: 'calendar/deliveries',
    component: DeliverysComponent,
    resolve: { title: TitleResolver }, 
    canActivate: [RoleAccountGuard],
    data: { 
      title: 'titles-menu-pages.deliverys', 
      role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], 
      account_type: ['supplier', 'broker'] 
    },
  },
  {
    path: 'calendar/deliveries/:reference',
    component: DeliverysComponent,
    resolve: { title: TitleResolver }, 
    canActivate: [RoleAccountGuard],
    data: { 
      title: 'titles-menu-pages.deliverys', 
      role: ['Admin', 'Supervisor', 'Agent', 'Logistics'], 
      account_type: ['supplier', 'broker'] 
    },
  },
];

export function getFilteredDeliverysRoutes(accountType: string, role: string): Routes {
  return deliverysRoutes.filter(route => {
    const allowedRoles = route.data?.['role'];
    const allowedAccountTypes = route.data?.['account_type'];
    const roleAllowed = !allowedRoles || allowedRoles.includes(role);
    const accountTypeAllowed = !allowedAccountTypes || allowedAccountTypes.includes(accountType);
    return roleAllowed && accountTypeAllowed;
  });
}